import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AxiosApiClient from '../../components/utils/AxiosApiClient';
import AuthUtility from '../../components/frontend/auth/AuthUtility';
import { LogoutService } from '../../components/utils/LogoutService';

import OffCanvasNav from './OffCanvasNav';

import swal from 'sweetalert';

import logo from '../../assets/frontend/images/logo.png';

const OnCanvasHeader = () => {

	//logout should be its own component
	const navHistory = useNavigate();

	// using hooks
	const [isLoading, setIsLoading] = useState(false);
	const [labelIndex, setLabelIndex] = useState(0);

	const labels = [
		{ title: "Romergence", tagline: "Out of the Abyss", flag: "🇺🇸" },
		{ title: "Romergeus", tagline: "De Ortu Abyssi", flag: "🇻🇦" },
		{ title: "Romergencia", tagline: "Del Surgir del Abismo", flag: "🇪🇸" }
	];

	var RoleDashboardLink = '';
	var RoleAccountLink = '';
	var RoleSettingsLink = '';
	var RoleFeatureLinks = '';
	var AllLinks = '';

	if (AuthUtility.isLoggedIn()) {

		RoleAccountLink = '/' + localStorage.getItem('auth_role') + '/profile';
		if (localStorage.getItem('auth_role') === 'member') {
			RoleDashboardLink = '/member/dashboard';
			RoleAccountLink = '/member/account';
			RoleSettingsLink = '/member/settings';

			RoleFeatureLinks = (
				<ul>
					<li className="menu2"><Link to={"/member/videos"} className="font-poppins font-size-14 font-weight-400 uppercase">Videos</Link></li>
					<li className="menu2"><Link to={"/member/payments"} className="font-poppins font-size-14 font-weight-400 uppercase">Payments</Link></li>
				</ul>
			);
		} else if (localStorage.getItem('auth_role') === 'admin') {
			RoleDashboardLink = '/admin/dashboard';
			RoleAccountLink = '/admin/account';
			RoleSettingsLink = '/admin/settings';

			RoleFeatureLinks = (
				<ul>
					<li className="menu2"><Link to={"/admin/plans"} className="font-poppins font-size-14 font-weight-400 uppercase">Plans</Link></li>
					<li className="menu2"><Link to={"/admin/users"} className="font-poppins font-size-14 font-weight-400 uppercase">Users</Link></li>
					<li className="menu2"><Link to={"/admin/subscriptions"} className="font-poppins font-size-14 font-weight-400 uppercase">Subscript</Link></li>
				</ul>
			);
		}

		AllLinks = (
			<nav className="nav horizontal-container float-right">
				<ul className="element">
					<li className="dropdown text-center">
						<Link to="/home" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Home</Link>
						<ul>
							<li className="menu1"><Link onClick={() => handleComingSoon('Search')} className="font-poppins font-size-14 font-weight-400 uppercase">Search</Link></li>
							<li className="menu1"><Link onClick={() => handleComingSoon('About')} className="menu1 font-poppins font-size-14 font-weight-400 uppercase">About</Link></li>
							<li className="menu1"><Link onClick={() => handleComingSoon('Contact')} className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Contact</Link></li>
							<li className="menu1"><Link to="/help" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Help</Link></li>
						</ul>
					</li>
					<li className="dropdown text-center">
						<Link to={RoleDashboardLink} className="menu2 font-poppins font-size-14 font-weight-400 uppercase">Dashboard</Link>
						{RoleFeatureLinks}
					</li>
					<li className="dropdown text-center">
						<Link to={RoleAccountLink} className="menu3 font-poppins font-size-14 font-weight-400 uppercase">{localStorage.getItem('auth_name')}</Link>
						<ul>
							<li className="menu3"><Link to={RoleAccountLink} className="menu3 font-poppins font-size-14 font-weight-400 uppercase">Account</Link></li>
							<li className="menu3"><Link to={RoleSettingsLink} className="menu3 font-poppins font-size-14 font-weight-400 uppercase">Settings</Link></li>
							<li className="menu3"><Link to="#" className="menu3 font-poppins font-size-14 font-weight-400 uppercase" onClick={() => LogoutService({ setIsLoading, navHistory, swal })}>Logout</Link></li>
						</ul>
					</li>
				</ul>
			</nav>
		);
	} else {

		AllLinks = (
			<nav className="nav horizontal-container float-right">
				<ul className="element">
					<li className="dropdown text-center">
						<Link to="/login" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Login</Link>
					</li>
					<li className="dropdown text-center">
						<Link to="/register" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Register</Link>
					</li>
					<li className="dropdown text-center">
						<Link to="/home" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Home</Link>
						<ul>
							<li className="menu1"><Link onClick={() => handleComingSoon('Search')} className="font-poppins font-size-14 font-weight-400 uppercase">Search</Link></li>
							<li className="menu1"><Link onClick={() => handleComingSoon('About')} className="menu1 font-poppins font-size-14 font-weight-400 uppercase">About</Link></li>
							<li className="menu1"><Link onClick={() => handleComingSoon('Contact')} className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Contact</Link></li>
							<li className="menu1"><Link to="/help" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Help</Link></li>
						</ul>
					</li>
				</ul>
			</nav>
		);
	}
	// Touch handler for mobile focus clearing
	function handleTouchEnd(e) {
		e.currentTarget.blur();
	}

	function handleComingSoon(text) {

		swal("Info", text + " Coming Soon.", "info");
	}

	useEffect(() => {
		const interval = setInterval(() => {
			setLabelIndex((i) => (i + 1) % labels.length);
		}, 10000); // matches fade timing

		return () => clearInterval(interval);
	}, []);

	const currentLabel = labels[labelIndex];

	return (
		<div className="sticky-top z-index-1000">
			<div className="sticky bg-fafafa bb1-ddd plr-20l-10sz">

				<div className="panel large">

					<div id="nav_bar" className="horizontal-container nav-bar">
						<div className="align-left nav-bar-leftX">
							<Link to="/home" className="hover-opacity-50" onClick={(e) => { handleTouchEnd(e); }} onTouchEnd={(e) => { handleTouchEnd(e); }}>
								<div className="rotating-container horizontal-container justify-left gap-md">
									<span className="">
										<img src={logo} className="hide-for-small-only" alt="logo" width="65" />
										<img src={logo} className="show-for-small-only" alt="logo" width="48" />
									</span>
									{/*
									<span className="">
										<div className="font-orbitron font-size-24 font-weight-800 letter-spacing-0px uppercase italic pt-10 hide-for-small-only">ROMERGENCE</div>
										<div className="font-orbitron font-size-18 font-weight-500 letter-spacing-1px italic pt-15 pl-15 hide-for-small-only">De Ortu Abyssi</div>
										<div className="font-orbitron font-size-16 font-weight-800 letter-spacing-0px uppercase italic pt-7 show-for-small-only">ROMERGENCE</div>
										<div className="font-orbitron font-size-12 font-weight-500 letter-spacing-1px italic pt-5 pl-7 show-for-small-only">De Ortu Abyssi</div>
									</span>
									*/}
									{/* ROTATING TEXT ONLY */}
									<span key={labelIndex} className="text-block fade-cycle">
										<div className="font-orbitron font-size-24l-20m-18s font-weight-800 letter-spacing-0px uppercase italic pt-5">{currentLabel.title}</div>
										<div className="font-orbitron font-size-18l-14m font-weight-500 letter-spacing-1px italic pt-10l-5s">{currentLabel.tagline}</div>
									</span>
								</div>
							</Link>
						</div>
						<div className="align-right nav-bar-rightX hide-for-small-only">
							{AllLinks}
						</div>
						<div className="align-right nav-bar-rightX show-for-small-only">
							<OffCanvasNav />
						</div>
					</div>
				</div>

			</div>
		</div>
	);
}

export default OnCanvasHeader;